import React, { useContext } from 'react';

import Application from './steps/application';
//import PICS from './steps/pics';

import l10n from './localization';
import { FormContext } from '../core/layoutElements';
import Form from '../form';
import moment from 'moment';

export const localization = l10n;

export const inputSteps = [
    //PICS,
    Application,
];

export const Intro = () => {
    const {formLocalization} = useContext(FormContext);

    return (
        <>
            <p>{formLocalization.intro_line1}</p>
        </>
    );
}

const submitTransformFunc = (formData, dispatch) => {
    let now = new Date();
    let refNum = now.valueOf().toString();
    refNum = refNum.substr(0, refNum.length-3);
    return {
        ...formData,
        refNum: "LRWS1-"+refNum,
        __customReference: "LRWS1-"+refNum,
        Date: moment(now).format('YYYY-MM-DD'), //now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate(),
        Time: moment(now).format('HH:mm:ss'), // now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds(),
    }

    // return newFormData;
};

export const form = {
    steps: inputSteps,
    screenId: "LRWS1",
    code: "LRWS1",
    reference: "LR/WS/1",
    validFrom: "2020/11/05",
    intro: Intro,
    localization: localization,
    paymentRequired: false,
    // signRequired: true,
    signRequired: false,
    emeRequired: false,
    // signFields: ["Signature1"],
    resumeFromStepIdx: 0,
    skipAckEmail: true,
    //skipReview: true,
    //skipConfirm: true,
    simplifiedForm: true,
    customRefNumber: formData => submitTransformFunc(formData).refNum,
    resumeRetainFormDataKeys: [ 
                                "ackEmail",
                                "receiveAckEmail",
                            ],
    submitTransformFunc: submitTransformFunc,
}



export default ({currentLang}) => <Form formId={form.code} form={form} currentLang={currentLang} />;
